import { render, staticRenderFns } from "./ProductBatchDialog.vue?vue&type=template&id=33f89bb8&scoped=true"
import script from "./ProductBatchDialog.vue?vue&type=script&lang=js"
export * from "./ProductBatchDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductBatchDialog.vue?vue&type=style&index=0&id=33f89bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f89bb8",
  null
  
)

export default component.exports